import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FeatureFlagCode } from './feature-flag-codes';

/**
 * Active platform feature flags. Loaded once, lazily, by the product shell —
 * marketing-only visitors never pay the request. A failed fetch degrades to
 * "everything off", matching the backend contract (absence = off).
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private readonly http = inject(HttpClient);
  private readonly active = signal<ReadonlySet<string>>(new Set());
  private loadStarted = false;

  readonly loaded = signal(false);

  load(): void {
    if (this.loadStarted) return;
    this.loadStarted = true;
    this.http.get<string[]>(`${environment.apiUrl}/api/${environment.apiVersion}/feature-flags`)
      .pipe(catchError(() => of([] as string[])))
      .subscribe(codes => {
        this.active.set(new Set(codes));
        this.loaded.set(true);
      });
  }

  isEnabled(code: FeatureFlagCode): boolean {
    return this.active().has(code);
  }
}
